'use client';
import Slider from '@components/Slider';
import AnimatedHeadings from '@components/AnimatedHeadings';
import AnimatedParagraphs from '@components/AnimatedParagraphs';
import styles from './index.module.scss';
import { Montserrat } from 'next/font/google';
import { useOurServices } from './useOurServices';

const montserrat = Montserrat({ subsets: ['latin'] });

const OurServices = () => {
  const { t, translatedCarouselConfig } = useOurServices();

  return (
    <>
      <div
        className={`${styles.container} ${montserrat.className}`}
        data-id={'services'}
        id={'services'}
      >
        <AnimatedHeadings el="h1" text={t('heading')} repeatDelay={10000} />
        <AnimatedParagraphs>{t('intro')}</AnimatedParagraphs>
      </div>
      <Slider sliderData={translatedCarouselConfig} />
    </>
  );
};

export default OurServices;
